import styled from '@emotion/styled'

export const Cont = styled.div((props)=>({
  display:'flex',
  flex:1,
  flexDirection:'column',

  '.subCont':{
    display:'flex',

    '.field':{
      marginLeft:'1rem',
    },
  }
}))

export const ModalAction = styled.div((props)=>({
  padding: '1rem 1rem',
  textAlign: 'right',
}))

